import { HelmetExtension } from 'abi'
import { HoverInp, setPopup } from 'components'
import { CheckFillIcon, CloseIcon, WarningIcon } from 'icons'
import { Component, createMemo, For, onCleanup } from 'solid-js'
import { createStore, produce } from 'solid-js/store'
import { deepcopy, objentries } from 'utils/tools'
import {
    EXT_MANUALS_LABELS,
    FORMATS,
    HEL_EXT_COL_MAP,
    HELMET_EXTENSION_DEF,
} from './submitteds'

interface SelectProps {
    count: number
    show: boolean

    pickCorp: boolean

    onClose(): void
    onSave(h: HelmetExtension): void
}
const SelectedExtentions: Component<SelectProps> = P => {
    type STATE = {
        h: HelmetExtension
    }

    const STATE_DEF: STATE = {
        h: deepcopy(HELMET_EXTENSION_DEF),
    }
    const [state, setState] = createStore<STATE>(deepcopy(STATE_DEF))

    onCleanup(() => {
        setState(deepcopy(STATE_DEF))
    })

    type COMPARE_T = Omit<HelmetExtension, 'id'>
    const keys: (keyof COMPARE_T)[] = [
        'helmet',
        'issuer',
        'passenger_count',
        'third_party_insurance_amount',
        'plate_number',
        'unique_code',
        'issue_date',
        'created_at',
        'insurer_phone',
        'v_color',
        'transaction_number',
        'v_name',
        'chassis',
        'v_usage',
        'issue_time',
        'start_date',
        'life_surplus_insurance_amount',
        'ext_code',
        'engine',
        'v_system',
        'ext_number',
        'ext_row',
        'passenger_insurance_amount',
        'insurer_code',
        'transaction_kind',
        'fund_fine',
        'insurance_number',
        'issuer_code',
        'print_count',
        'total_insurance_amount',
        'v_group',
        'ext_issue_date',
        'expiration_date',
        'added_tax',
        'plate_serial',
        'issue_year',
        'airrm_cover_passenger',
        'airrm_cover_financial',
        'apply_date',
        'manufacture_year',
        'plate_city',
        'transaction_detail',
        'ext_change',
        'financial_surplus_insurance_amount',
        'insurance_code',
        'insurer',
        'transaction_summary',
        'airrm_cover_life',
        'vin',
        'past_insurer',
        'added_toll',
        'past_expiration_date',
        'economic_number',
        'reagent',
    ]
    const changed = createMemo(() => {
        const h = state.h as Partial<COMPARE_T> | undefined
        const p = HELMET_EXTENSION_DEF as Partial<COMPARE_T> | undefined

        if (!h && !p) return false

        if (!h || !p) return true

        return keys.some(k => {
            const a = h[k]
            const b = p[k]

            if (a == null && b == null) return false

            return String(a ?? '') !== String(b ?? '')
        })
    })

    const onClose = () => {
        if (changed()) {
            setPopup({
                show: true,
                title: 'ذخیره نکردید!',
                content: 'بعد از خروج تغییرات شما ذخیره نمیشوند!',
                Icon: WarningIcon,
                type: 'warning',
                onSubmit: P.onClose,
            })
            return
        }

        P.onClose()
    }
    const onSave = () => {
        P.onSave(deepcopy(state.h))
    }

    function helmet_update(body: Partial<HelmetExtension>) {
        setState(
            produce(s => {
                for (let [k, v] of Object.entries(body)) {
                    // @ts-ignore
                    s.h[k] = v
                }
            })
        )
    }

    return (
        <div class='select-cmp-container'>
            <div class='select-ctas'>
                <button
                    class='save-select title_smaller'
                    type='button'
                    onclick={onSave}
                    disabled={!changed()}
                >
                    <CheckFillIcon />
                    تایید
                </button>

                <button
                    class='close-select icon'
                    type='button'
                    onclick={onClose}
                >
                    <CloseIcon />
                </button>
            </div>

            <div class='select-counter'>
                <span class='main section_title'>{P.count}</span>
                <span class='sub title_small'>بیمه انتخاب شده</span>
            </div>
            <div class='inputs'>
                <For each={objentries(EXT_MANUALS_LABELS)}>
                    {([k, v]) => {
                        const key = k as keyof HelmetExtension

                        return (
                            <HoverInp
                                holder={v}
                                value={String(state.h![key] || '')}
                                onInp={e => helmet_update({ [k]: e })}
                                acitve={!!state.h?.[k]}
                                id={`inp-${String(k)}`}
                                inpType={
                                    typeof HELMET_EXTENSION_DEF[k] == 'number'
                                        ? 'number'
                                        : 'text'
                                }
                                Icon={null}
                                format={FORMATS.includes(k)}
                            />
                        )
                    }}
                </For>
                <For each={objentries(HEL_EXT_COL_MAP)}>
                    {([k, { cn }]) => (
                        <HoverInp
                            holder={cn.filter(Boolean)[0]!}
                            value={String(state.h![k] || '')}
                            onInp={e => helmet_update({ [k]: e })}
                            acitve={!!state.h?.[k]}
                            id={`inp-${String(k)}`}
                            inpType={
                                typeof HELMET_EXTENSION_DEF[k] == 'number'
                                    ? 'number'
                                    : 'text'
                            }
                            Icon={null}
                            format={FORMATS.includes(k)}
                        />
                    )}
                </For>
            </div>
        </div>
    )
}

export default SelectedExtentions
